import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, watch } from '@nuxtjs/composition-api';
import type { Props as IconProps } from '~/core/components/base/image/SvgThemedIcon.vue';

interface Props {
    size?: 'm' | 'l',
    disabled?: boolean,
    theme?: 'light' | 'dark',
    offIcon?: IconProps,
    onIcon?: IconProps,
    value?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MonochromeIconedToggle',
  props: {
    size: { default: 'm' },
    disabled: { type: Boolean, default: false },
    theme: null,
    offIcon: null,
    onIcon: null,
    value: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { size: 'm' | 'l', disabled: boolean, theme?: 'light' | 'dark', offIcon?: IconProps, onIcon?: IconProps, value?: boolean };





const {
    size,
    disabled,
    theme,
    offIcon,
    onIcon,
    value,
} = toRefs(props);

const internalValue = ref(value.value);
watch(value, (newValue) => {
    internalValue.value = newValue;
});
watch(internalValue, (newValue) => {
    $emit('input', newValue);
});
const iconSize = computed(() => size.value === 'l' ? 'm' : 's');


return { __sfc: true,$emit, props, size, disabled, theme, offIcon, onIcon, value, internalValue, iconSize }
}

})